<template lang="html">

  <div>

    <!-- Mensagem de confirmação exibida após o usuário clicar no botão para submeter o relatório técnico de extensão para aprovação. -->
    <c-confirm-dialog v-model="dialogSubmeterRelatorioAprovacao" @yes="submeterRelatorioAprovacao()" titulo="Submeter o relatório para aprovação?">
      Submeter o relatório para aprovação nesta plataforma não garante o seu recebimento pela ProEx!
      É necessário autuar um processo digital (com o espelho do relatório em anexo), 
      encaminhá-lo à ProEx (seguir o procedimento do Anexo II, disponível no Menu AJUDA deste portal) e aguardar deliberação da Câmara de Extensão.
      Maiores informações entre em contato através do e-mail <a href="mailto:suporte.proex@ufes.br">suporte.proex@ufes.br</a>.
    </c-confirm-dialog>

    <v-container class='fluid'>
      <v-layout align-center justify-center>
        <v-flex xs10>
          <v-card class="text-xs-center">
            <basic-toolbar title="Submeter relatório técnico para aprovação"></basic-toolbar>
            <v-card-text>
              <v-form v-model="formularioValido" ref="form">
                <v-container>

                  <!-- Título -->
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12 sm11>
                      <c-readonly-field label='Título' :value="this.relatorio.tituloAcaoExtensao"></c-readonly-field>
                    </v-flex>
                  </v-layout>

                  <!-- Número -->
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12 sm11>
                      <c-readonly-field label='Número' :value="this.relatorio.numeroAcaoExtensao"></c-readonly-field>
                    </v-flex>
                  </v-layout>

                  <!-- Coordenador -->
                  <v-layout row>
                    <v-flex xs12>
                      <c-readonly-field v-if="this.relatorio.nomeCoordenador !== null" label="Coordenador" :value="this.relatorio.nomeCoordenador"></c-readonly-field>
                      <c-readonly-field v-else label="Coordenador" value="-"></c-readonly-field>
                    </v-flex>
                  </v-layout>

                  <!-- Relatório-->
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12 sm11>
                      <c-readonly-field label='Relatório' :value="'Relatório Técnico de Extensão ' + relatorio.ordem"></c-readonly-field>
                    </v-flex>
                  </v-layout>

                  <!-- Tipo do relatório-->
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12 sm11>
                      <c-readonly-field
                        v-if="relatorio.tipoRelatorioTecnicoItem === 1"
                        label="Tipo do relatório"
                        value="Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."
                        ></c-readonly-field>

                        <c-readonly-field
                        v-if="relatorio.tipoRelatorioTecnicoItem === 2"
                        label="Tipo do relatório"
                        value="Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
                        ></c-readonly-field>

                        <c-readonly-field
                        v-if="relatorio.tipoRelatorioTecnicoItem === 3"
                        label="Tipo do relatório"
                        value="Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
                        ></c-readonly-field>

                        <c-readonly-field
                        v-if="!relatorio.tipoRelatorioTecnicoItem"
                        label="Tipo do relatório"
                        value="-"
                        ></c-readonly-field>
                    </v-flex>
                  </v-layout>

                  <!-- Período a que se refere o relatório -->
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12>
                      <label>Período a que se refere o relatório</label>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-space-between>
                    <v-flex md5 xs12 >
                      <c-readonly-field label="Início:" :value="relatorio.dtInicialFormatada"></c-readonly-field>
                    </v-flex>
                    <v-flex md1></v-flex>
                    <v-flex md5 xs12>
                      <c-readonly-field label="Fim:" :value="relatorio.dtFinalFormatada"></c-readonly-field>
                    </v-flex>
                    <v-flex md1></v-flex>
                  </v-layout>
                  
                  <br>

                  <v-divider></v-divider>

                  <v-card-actions>

                    <!-- Botão "Cancelar" -->
                    <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>

                    <v-spacer></v-spacer>

                    <!-- Botão "Submeter" -->
                    <v-btn color="primary" text @click="botaoSubmeterRelatorioAprovacao()" :disabled="!formularioValido">Submeter</v-btn>

                  </v-card-actions>

                </v-container>
              </v-form>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  
  </div>

</template>

<script>
import ConfirmDialog from '@/components/c-confirm-dialog'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import DataMenu from '@/components/c-date-menu'
import TextArea from '@/components/c-textarea'
import ReadonlyField from '@/components/c-readonly-field'
import projetos from '@/utils/projetos'
import dates from '@/utils/dates'
import { mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'idRelatorio'],
  data: () => ({
    relatorio: {},
    submissao: {},
    dialogSubmeterRelatorioAprovacao: false,
    formularioValido: false,
    regrasBasicas: [
      (input) => !!input || 'Este campo é obrigatório'
    ]
  }),
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    botaoSubmeterRelatorioAprovacao: function () {
      this.dialogSubmeterRelatorioAprovacao = true
    },
    cancelar: function () {
      this.$router.push({name: 'RelatoriosProjeto', params: {idProjeto: this.idProjeto}})
    },
    submeterRelatorioAprovacao: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo relatório de extensão para aprovação.' })
      projetos.postSubmeterRelatorio(this.idProjeto, this.idRelatorio, this.submissao)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.$router.push({name: 'RelatoriosProjeto', params: {idProjeto: this.idProjeto}})
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo relatório de extensão para aprovação.' })
      })
    }
  },
  mounted () {
    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' })
    projetos.getRelatorioExtensao(this.idProjeto, this.idRelatorio)
    .then(response => {
      this.relatorio = response.data
      this.relatorio.dtInicialFormatada = dates.format(this.relatorio.dtInicial)
      this.relatorio.dtFinalFormatada = dates.format(this.relatorio.dtFinal)
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
      this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-date-menu': DataMenu,
    'c-textarea': TextArea,
    'c-readonly-field': ReadonlyField,
    'c-confirm-dialog': ConfirmDialog
  }
}
</script>



// WEBPACK FOOTER //
// submeter.vue?9416f816